<template>
  <div class="app flex-row align-items-center">

  <!-- Inserimento dell'indirizzo email per recupero della paswword -->
  <div class="container-fluid" v-if="!recuperoPassword">
    <b-row class="justify-content-center">   
      <b-col xs="8" xl="3" lg="4" md="4" sm="6" class="col d-flex align-items-center "> 
        <b-form class="justify-content-center">
          <div class="mb-3">
              <img class="justify-content-center img-fluid" src="/img/logo_new.png">
          </div>
          <div><label class="bold-18 mt-3">{{this.$t("passwordrecovery")}}</label></div>
          <div><label class="typo-label">{{this.$t("typemail")}}</label></div>
                  
          <b-form-group>
            <b-input-group class="mb-3">   
              <b-input-group-prepend><b-input-group-text><i class="icon-envelope"></i></b-input-group-text></b-input-group-prepend>
              <b-form-input v-model="email" type="text"  :placeholder="this.$t('signup.email')" :state="validation_email" class="form-control typo-signup"/>
              <b-form-invalid-feedback class="ml-5" :state="validation_email">{{$t("signup.validation_email")}}</b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>

     
            <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged">
            <p>{{ alertMessage }}</p>
            </b-alert>

          <b-row class="justify-content-center">
            <b-button pill @click="forgotPassword" variant="primary" class="px-5 mt-3 ml-3 but-pill"><span class="text-pill">{{this.$t("sendbutton")}}</span></b-button>
          </b-row>

        </b-form>
      </b-col>
    </b-row>
  </div>

  <!-- Inserimento del codice di verifica dopo la procedura di recupero della password -->
  <div class="container-fluid" v-if="recuperoPassword">
    <b-row class="justify-content-center">
      <b-col xs="8" xl="4" lg="5" md="6" sm="6" class="col d-flex align-items-center "> 
        <b-form class="justify-content-center">
          <div class="mb-3 text-center">
              <img class="img-fluid" src="/img/logo_new.png">
          </div>
          <div class="text-center"><label class="bold-18 mt-3">{{this.$t("signup.completePasswordRecovery")}}</label></div>
          <div class="text-center mt-3"><label class="typo-label">{{this.$t("signup.insertCodePassword")}}</label></div>
          
          <!--Verification code-->
          <b-form-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-key"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input v-model="code" type="text" :state="validation_code"   :placeholder="$t('signup.code')" class="form-control typo-signup"/>
                <b-form-invalid-feedback class="ml-5" :state="validation_code">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
              </b-input-group>
          </b-form-group>
          
          <!-- form signup password -->
          <b-form-group>
              <b-input-group class="mb-3 mt-3">    
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>   
                  <b-form-input v-model="password" type="password" :placeholder="$t('signup.password')" :state="validation_password" class="form-control typo-signup"/>
                  <b-form-invalid-feedback class="ml-5" :state="validation_password">{{$t("signup.validation_password")}}</b-form-invalid-feedback>
              </b-input-group>
          </b-form-group>

         
          <!-- form signup confirm password -->
          <b-form-group>
              <b-input-group class="mb-3">    
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>   
                  <b-form-input v-model="passwordConfirm" type="password" :placeholder="$t('signup.confirmpassword')" :state="validation_passwordConfirm" class="form-control typo-signup"/>
                  <b-form-invalid-feedback class="ml-5" :state="validation_passwordConfirm">{{$t("signup.validation_passwordConfirm")}}</b-form-invalid-feedback>
              </b-input-group>
          </b-form-group>

            <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="danger"
              @dismissed="dismissCountDown=0"
              @dismiss-count-down="countDownChanged">
            <p>{{ alertMessage }}</p>
            </b-alert>


          <b-row class="justify-content-center">
            <b-button pill @click="resetPassword" variant="primary" class="px-5 mt-3 ml-3 but-pill"><span class="text-pill">{{this.$t("sendbutton")}}</span></b-button>
          </b-row>

        </b-form>
      </b-col>
    </b-row>
  </div>

  </div>  
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'

export default {
  name: 'PasswordDimenticata',
  props: [],
  data() {
      return {
          email: '',
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
          password: '',
          passwordConfirm: '',
          recuperoPassword:false,
          currUser: null,
          code: '',
          dismissSecs: 5,
          dismissCountDown: 0,
          alertMessage:"",
          submit:"",
          resetP: "",
          regex_password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/  //Minimo 8 caratteri, almeno un numero, un carattere minuscolo, un carattre maiuscolo e un carattere speciale

      }
  },
  computed:{
    validation_email() {
      if (this.submit == true) 
      {
        if(this.email.length>0 && this.reg.test(this.email))
         return true
        else
         return false 
      }  
    },
    validation_code() {
      if (this.resetP == true) return this.code.length > 0;
    },
    validation_password() {
      if (this.resetP == true) 
      {
        if(this.regex_password.test(this.password))  //Minimo 8 caratteri, almeno un numero, un carattere minuscolo, un carattre maiuscolo e un carattere speciale
          return true
        else
          return false
      }  
    },
    validation_passwordConfirm() {
      if (this.resetP == true) 
      {
        if(this.passwordConfirm.length >= 8 && this.password==this.passwordConfirm)
          return true
        else
          return false
      }  
    },
  },
  methods: {
    forgotPassword()
    {
        this.submit=true;
        if(!this.validation_email) return 
        
        //catch forgot password button click
        Auth.forgotPassword(this.email)
            .then(data => 
            {
              //On ok insert code received by mail 
              console.log("Avvia il recupero password", data)
              this.recuperoPassword=true;
            })
            .catch(err => 
            {
              //On error "Show alert" for 5 seconds 
              var codiceErr=err.code;
              console.log("Errore nel recupero password" , err);
              this.alertMessage=this.$t("signup."+codiceErr);
              this.showAlert();          
              this.recuperoPassword=false;
            });
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
        this.dismissCountDown = this.dismissSecs
      },
    gotoRegistrati() {
      this.$router.push('/registrati');
    },  
    resetPassword()
    {
      this.resetP=true;
      if (!this.validation_code || !this.validation_password || !this.validation_passwordConfirm) return;
      console.log("Invia new password");
      // Collect confirmation code and new password, then
      Auth.forgotPasswordSubmit(this.email, this.code, this.password)
      .then(data => 
      {
        this.$router.push('/login');
      })
      .catch( err =>
        {
          //On code error "Show alert" for 5 seconds 
          var codiceErr=err.code;
          this.alertMessage=this.$t("signup."+codiceErr);
          this.showAlert(); 
        });
    }
  }
}
</script>